import React from 'react'
import classnames from '@helpers/misc/classnames'

export interface Props {
  totalSteps: number
  step?: number
  icon?: React.ReactNode
  pulseWhenNotCompleted?: boolean
}

export default function Timeline({
  totalSteps,
  step = 1,
  icon,
  pulseWhenNotCompleted = true
}: Props) {
  const stepWidth = Math.floor(100 / totalSteps)

  return (
    <div className="flex items-center h-8">
      {Array.from({length: totalSteps}).map((_, index) => {
        const isCompleted = index < step
        const isCurrStep = step - 1 === index
        return (
          <div className="px-[1px]" key={index} style={{width: `${stepWidth}%`}}>
            <div
              className={classnames({
                'h-3 w-full flex justify-center items-center': true,
                'bg-slate-800 dark:bg-slate-300': isCompleted,
                'bg-slate-200 dark:bg-slate-700': !isCompleted,
                'animate-pulse': isCurrStep && step !== totalSteps && pulseWhenNotCompleted,
                'rounded-l-lg': index === 0,
                'rounded-r-lg': index === totalSteps - 1
              })}>
              {isCurrStep ? (
                <div className="flex items-center justify-center rounded-full h-6 w-6 bg-slate-800 dark:bg-slate-300">
                  {icon}
                </div>
              ) : null}
            </div>
          </div>
        )
      })}
    </div>
  )
}
